module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": _vm.appRoot
    }
  }, [_c('logo')], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "static/devDocs.pdf",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "book"
    }
  }), _vm._v(" API")], 1)]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/docs"
    }
  }, [_c('icon', {
    attrs: {
      "name": "book"
    }
  }), _vm._v(" Help")], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e8a64638!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainBar.vue
// module id = 1558
// module chunks = 2